import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";
import { Button, Group } from "@/components/ui";

interface Props {
  checklistCompleto: boolean;
  enviadaAAutorizacion: boolean;
  puedeAdjuntar: boolean;
  fueRechazada: boolean;
  nivelDelRechazo: number | null;
  enviando: boolean;
  reenviando: boolean;
  onVolver: () => void;
  onEnviar: () => void;
  onReenviar: () => void;
}

/**
 * Botonera del paso "Documentos":
 *   Izquierda: "Regresar a Prorrateo" · cumple ambos roles · navegacion
 *   lineal del wizard Y "corregir prorrateo si te equivocaste" (mismo
 *   destino, mismo efecto · antes habia dos botones redundantes).
 *   Derecha: Reenviar (si fue rechazada) o Enviar a autorizacion.
 */
export function DocumentosActions({
  checklistCompleto,
  enviadaAAutorizacion,
  puedeAdjuntar,
  fueRechazada,
  nivelDelRechazo,
  enviando,
  reenviando,
  onVolver,
  onEnviar,
  onReenviar,
}: Props) {
  return (
    <Group justify="space-between">
      <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={onVolver}>
        Regresar a Prorrateo
      </Button>

      {fueRechazada ? (
        <Button rightSection={<IconArrowRight size={14} />} disabled={!checklistCompleto} loading={reenviando} onClick={onReenviar}>
          {reenviando ? "Reenviando…" : checklistCompleto ? `Reenviar al nivel ${nivelDelRechazo}` : "Checklist incompleto"}
        </Button>
      ) : (
        <Button rightSection={<IconArrowRight size={14} />} disabled={!checklistCompleto || enviadaAAutorizacion || !puedeAdjuntar} loading={enviando} onClick={onEnviar}>
          {enviando ? "Enviando…" : enviadaAAutorizacion ? "Ya enviada a autorización" : checklistCompleto ? "Enviar a autorización" : "Checklist incompleto"}
        </Button>
      )}
    </Group>
  );
}
